import React from 'react';
import { Form } from 'react-bootstrap';

// Used in both first and second steps
const DescriptionInput = (props) => {
  const {
    description,
    setDescription,
    validationError,
    isGlobalPay,
    allowSyncerWriteback,
  } = props;

  return (
    <Form.Group controlId='description'>
      {isGlobalPay ? (
        <Form.Label>Invoice ID (max 8 characters)</Form.Label>
      ) : (
        <Form.Label>Description</Form.Label>
      )}
      <Form.Control
        type='text'
        name='description'
        placeholder={isGlobalPay ? 'Invoice ID' : 'Invoice ID/Patient Name'}
        defaultValue={description}
        maxLength={isGlobalPay ? 8 : 100}
        isInvalid={!!validationError}
        onChange={(event) => {
          setDescription(event.target.value);
        }}
      />
      <Form.Control.Feedback type='invalid'>
        {validationError}
      </Form.Control.Feedback>
      {allowSyncerWriteback && (
        <Form.Text className='text-muted'>Use PMS Id for Writeback</Form.Text>
      )}
    </Form.Group>
  );
};

export default DescriptionInput;
